// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file catpocs/v1/ecr_admin.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file catpocs/v1/ecr_admin.proto.
 */
export const file_catpocs_v1_ecr_admin: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Registry overview statistics
 *
 * @generated from message catpocs.v1.RegistryStats
 */
export type RegistryStats = Message<"catpocs.v1.RegistryStats"> & {
  /**
   * @generated from field: int32 total_repositories = 1;
   */
  totalRepositories: number;

  /**
   * @generated from field: int64 total_images = 2;
   */
  totalImages: bigint;

  /**
   * @generated from field: int64 total_storage_bytes = 3;
   */
  totalStorageBytes: bigint;

  /**
   * @generated from field: int32 images_with_vulnerabilities = 4;
   */
  imagesWithVulnerabilities: number;

  /**
   * @generated from field: int32 critical_vulnerabilities = 5;
   */
  criticalVulnerabilities: number;

  /**
   * @generated from field: int32 high_vulnerabilities = 6;
   */
  highVulnerabilities: number;
};

/**
 * Describes the message catpocs.v1.RegistryStats.
 * Use `create(RegistryStatsSchema)` to create a new message.
 */
export const RegistryStatsSchema: GenMessage<RegistryStats> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 0);

/**
 * Repository information
 *
 * @generated from message catpocs.v1.RepositoryInfo
 */
export type RepositoryInfo = Message<"catpocs.v1.RepositoryInfo"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string uri = 2;
   */
  uri: string;

  /**
   * @generated from field: string created_at = 3;
   */
  createdAt: string;

  /**
   * @generated from field: int32 image_count = 4;
   */
  imageCount: number;
};

/**
 * Describes the message catpocs.v1.RepositoryInfo.
 * Use `create(RepositoryInfoSchema)` to create a new message.
 */
export const RepositoryInfoSchema: GenMessage<RepositoryInfo> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 1);

/**
 * Repository metrics
 *
 * @generated from message catpocs.v1.RepositoryMetrics
 */
export type RepositoryMetrics = Message<"catpocs.v1.RepositoryMetrics"> & {
  /**
   * @generated from field: int32 total_images = 1;
   */
  totalImages: number;

  /**
   * @generated from field: int64 total_size_bytes = 2;
   */
  totalSizeBytes: bigint;

  /**
   * @generated from field: int32 images_with_scan_findings = 3;
   */
  imagesWithScanFindings: number;

  /**
   * @generated from field: int32 critical_findings = 4;
   */
  criticalFindings: number;

  /**
   * @generated from field: int32 high_findings = 5;
   */
  highFindings: number;

  /**
   * @generated from field: string last_pushed_at = 6;
   */
  lastPushedAt: string;
};

/**
 * Describes the message catpocs.v1.RepositoryMetrics.
 * Use `create(RepositoryMetricsSchema)` to create a new message.
 */
export const RepositoryMetricsSchema: GenMessage<RepositoryMetrics> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 2);

/**
 * Repository with metrics
 *
 * @generated from message catpocs.v1.RepositoryWithMetrics
 */
export type RepositoryWithMetrics = Message<"catpocs.v1.RepositoryWithMetrics"> & {
  /**
   * @generated from field: catpocs.v1.RepositoryInfo repository = 1;
   */
  repository?: RepositoryInfo;

  /**
   * @generated from field: catpocs.v1.RepositoryMetrics metrics = 2;
   */
  metrics?: RepositoryMetrics;
};

/**
 * Describes the message catpocs.v1.RepositoryWithMetrics.
 * Use `create(RepositoryWithMetricsSchema)` to create a new message.
 */
export const RepositoryWithMetricsSchema: GenMessage<RepositoryWithMetrics> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 3);

/**
 * Image information
 *
 * @generated from message catpocs.v1.ImageInfo
 */
export type ImageInfo = Message<"catpocs.v1.ImageInfo"> & {
  /**
   * @generated from field: string digest = 1;
   */
  digest: string;

  /**
   * @generated from field: repeated string tags = 2;
   */
  tags: string[];

  /**
   * @generated from field: int64 size_bytes = 3;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string pushed_at = 4;
   */
  pushedAt: string;

  /**
   * @generated from field: string scan_status = 5;
   */
  scanStatus: string;
};

/**
 * Describes the message catpocs.v1.ImageInfo.
 * Use `create(ImageInfoSchema)` to create a new message.
 */
export const ImageInfoSchema: GenMessage<ImageInfo> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 4);

/**
 * Vulnerability scan findings
 *
 * @generated from message catpocs.v1.ScanFindings
 */
export type ScanFindings = Message<"catpocs.v1.ScanFindings"> & {
  /**
   * @generated from field: int32 critical_count = 1;
   */
  criticalCount: number;

  /**
   * @generated from field: int32 high_count = 2;
   */
  highCount: number;

  /**
   * @generated from field: int32 medium_count = 3;
   */
  mediumCount: number;

  /**
   * @generated from field: int32 low_count = 4;
   */
  lowCount: number;

  /**
   * @generated from field: int32 informational_count = 5;
   */
  informationalCount: number;

  /**
   * @generated from field: int32 total_findings = 6;
   */
  totalFindings: number;

  /**
   * @generated from field: string scan_status = 7;
   */
  scanStatus: string;

  /**
   * @generated from field: string scan_completed_at = 8;
   */
  scanCompletedAt: string;

  /**
   * @generated from field: repeated catpocs.v1.VulnerabilityFinding findings = 9;
   */
  findings: VulnerabilityFinding[];
};

/**
 * Describes the message catpocs.v1.ScanFindings.
 * Use `create(ScanFindingsSchema)` to create a new message.
 */
export const ScanFindingsSchema: GenMessage<ScanFindings> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 5);

/**
 * Individual vulnerability finding
 *
 * @generated from message catpocs.v1.VulnerabilityFinding
 */
export type VulnerabilityFinding = Message<"catpocs.v1.VulnerabilityFinding"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string severity = 2;
   */
  severity: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string uri = 4;
   */
  uri: string;
};

/**
 * Describes the message catpocs.v1.VulnerabilityFinding.
 * Use `create(VulnerabilityFindingSchema)` to create a new message.
 */
export const VulnerabilityFindingSchema: GenMessage<VulnerabilityFinding> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 6);

/**
 * Vulnerable image
 *
 * @generated from message catpocs.v1.VulnerableImage
 */
export type VulnerableImage = Message<"catpocs.v1.VulnerableImage"> & {
  /**
   * @generated from field: string repository_name = 1;
   */
  repositoryName: string;

  /**
   * @generated from field: string image_digest = 2;
   */
  imageDigest: string;

  /**
   * @generated from field: repeated string image_tags = 3;
   */
  imageTags: string[];

  /**
   * @generated from field: string pushed_at = 4;
   */
  pushedAt: string;

  /**
   * @generated from field: catpocs.v1.ScanFindings scan_findings = 5;
   */
  scanFindings?: ScanFindings;
};

/**
 * Describes the message catpocs.v1.VulnerableImage.
 * Use `create(VulnerableImageSchema)` to create a new message.
 */
export const VulnerableImageSchema: GenMessage<VulnerableImage> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 7);

/**
 * Unused image
 *
 * @generated from message catpocs.v1.UnusedImage
 */
export type UnusedImage = Message<"catpocs.v1.UnusedImage"> & {
  /**
   * @generated from field: string repository_name = 1;
   */
  repositoryName: string;

  /**
   * @generated from field: string image_digest = 2;
   */
  imageDigest: string;

  /**
   * @generated from field: repeated string image_tags = 3;
   */
  imageTags: string[];

  /**
   * @generated from field: string pushed_at = 4;
   */
  pushedAt: string;

  /**
   * @generated from field: int64 size_bytes = 5;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string last_deployed_at = 6;
   */
  lastDeployedAt: string;
};

/**
 * Describes the message catpocs.v1.UnusedImage.
 * Use `create(UnusedImageSchema)` to create a new message.
 */
export const UnusedImageSchema: GenMessage<UnusedImage> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 8);

/**
 * Repository details
 *
 * @generated from message catpocs.v1.RepositoryDetails
 */
export type RepositoryDetails = Message<"catpocs.v1.RepositoryDetails"> & {
  /**
   * @generated from field: catpocs.v1.RepositoryInfo repository = 1;
   */
  repository?: RepositoryInfo;

  /**
   * @generated from field: catpocs.v1.RepositoryMetrics metrics = 2;
   */
  metrics?: RepositoryMetrics;

  /**
   * @generated from field: repeated catpocs.v1.ImageInfo images = 3;
   */
  images: ImageInfo[];
};

/**
 * Describes the message catpocs.v1.RepositoryDetails.
 * Use `create(RepositoryDetailsSchema)` to create a new message.
 */
export const RepositoryDetailsSchema: GenMessage<RepositoryDetails> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 9);

/**
 * Cleanup result
 *
 * @generated from message catpocs.v1.CleanupResult
 */
export type CleanupResult = Message<"catpocs.v1.CleanupResult"> & {
  /**
   * @generated from field: bool dry_run = 1;
   */
  dryRun: boolean;

  /**
   * @generated from field: int32 repositories_scanned = 2;
   */
  repositoriesScanned: number;

  /**
   * @generated from field: int32 images_identified = 3;
   */
  imagesIdentified: number;

  /**
   * @generated from field: int32 images_deleted = 4;
   */
  imagesDeleted: number;

  /**
   * @generated from field: int32 images_failed = 5;
   */
  imagesFailed: number;

  /**
   * @generated from field: int64 storage_bytes_identified = 6;
   */
  storageBytesIdentified: bigint;

  /**
   * @generated from field: int64 storage_bytes_freed = 7;
   */
  storageBytesFreed: bigint;

  /**
   * @generated from field: repeated string errors = 8;
   */
  errors: string[];

  /**
   * @generated from field: repeated string warnings = 9;
   */
  warnings: string[];

  /**
   * @generated from field: string duration = 10;
   */
  duration: string;
};

/**
 * Describes the message catpocs.v1.CleanupResult.
 * Use `create(CleanupResultSchema)` to create a new message.
 */
export const CleanupResultSchema: GenMessage<CleanupResult> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 10);

/**
 * @generated from message catpocs.v1.GetRegistryOverviewRequest
 */
export type GetRegistryOverviewRequest = Message<"catpocs.v1.GetRegistryOverviewRequest"> & {
};

/**
 * Describes the message catpocs.v1.GetRegistryOverviewRequest.
 * Use `create(GetRegistryOverviewRequestSchema)` to create a new message.
 */
export const GetRegistryOverviewRequestSchema: GenMessage<GetRegistryOverviewRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 11);

/**
 * @generated from message catpocs.v1.GetRegistryOverviewResponse
 */
export type GetRegistryOverviewResponse = Message<"catpocs.v1.GetRegistryOverviewResponse"> & {
  /**
   * @generated from field: catpocs.v1.RegistryStats stats = 1;
   */
  stats?: RegistryStats;
};

/**
 * Describes the message catpocs.v1.GetRegistryOverviewResponse.
 * Use `create(GetRegistryOverviewResponseSchema)` to create a new message.
 */
export const GetRegistryOverviewResponseSchema: GenMessage<GetRegistryOverviewResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 12);

/**
 * @generated from message catpocs.v1.ListRepositoriesRequest
 */
export type ListRepositoriesRequest = Message<"catpocs.v1.ListRepositoriesRequest"> & {
  /**
   * Number of repositories per page (default: 20)
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Number of repositories to skip for pagination
   *
   * @generated from field: int32 skip = 2;
   */
  skip: number;

  /**
   * Search query to filter repositories by name
   *
   * @generated from field: string search = 3;
   */
  search: string;

  /**
   * Filter by security: "clean", "vulnerable", or empty for all
   *
   * @generated from field: string security_filter = 4;
   */
  securityFilter: string;
};

/**
 * Describes the message catpocs.v1.ListRepositoriesRequest.
 * Use `create(ListRepositoriesRequestSchema)` to create a new message.
 */
export const ListRepositoriesRequestSchema: GenMessage<ListRepositoriesRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 13);

/**
 * @generated from message catpocs.v1.ListRepositoriesResponse
 */
export type ListRepositoriesResponse = Message<"catpocs.v1.ListRepositoriesResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.RepositoryWithMetrics repositories = 1;
   */
  repositories: RepositoryWithMetrics[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListRepositoriesResponse.
 * Use `create(ListRepositoriesResponseSchema)` to create a new message.
 */
export const ListRepositoriesResponseSchema: GenMessage<ListRepositoriesResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 14);

/**
 * @generated from message catpocs.v1.GetRepositoryDetailsRequest
 */
export type GetRepositoryDetailsRequest = Message<"catpocs.v1.GetRepositoryDetailsRequest"> & {
  /**
   * @generated from field: string repository_name = 1;
   */
  repositoryName: string;
};

/**
 * Describes the message catpocs.v1.GetRepositoryDetailsRequest.
 * Use `create(GetRepositoryDetailsRequestSchema)` to create a new message.
 */
export const GetRepositoryDetailsRequestSchema: GenMessage<GetRepositoryDetailsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 15);

/**
 * @generated from message catpocs.v1.GetRepositoryDetailsResponse
 */
export type GetRepositoryDetailsResponse = Message<"catpocs.v1.GetRepositoryDetailsResponse"> & {
  /**
   * @generated from field: catpocs.v1.RepositoryDetails details = 1;
   */
  details?: RepositoryDetails;
};

/**
 * Describes the message catpocs.v1.GetRepositoryDetailsResponse.
 * Use `create(GetRepositoryDetailsResponseSchema)` to create a new message.
 */
export const GetRepositoryDetailsResponseSchema: GenMessage<GetRepositoryDetailsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 16);

/**
 * @generated from message catpocs.v1.GetVulnerableImagesRequest
 */
export type GetVulnerableImagesRequest = Message<"catpocs.v1.GetVulnerableImagesRequest"> & {
  /**
   * CRITICAL, HIGH, MEDIUM, LOW, INFORMATIONAL
   *
   * @generated from field: string min_severity = 1;
   */
  minSeverity: string;
};

/**
 * Describes the message catpocs.v1.GetVulnerableImagesRequest.
 * Use `create(GetVulnerableImagesRequestSchema)` to create a new message.
 */
export const GetVulnerableImagesRequestSchema: GenMessage<GetVulnerableImagesRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 17);

/**
 * @generated from message catpocs.v1.GetVulnerableImagesResponse
 */
export type GetVulnerableImagesResponse = Message<"catpocs.v1.GetVulnerableImagesResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.VulnerableImage images = 1;
   */
  images: VulnerableImage[];
};

/**
 * Describes the message catpocs.v1.GetVulnerableImagesResponse.
 * Use `create(GetVulnerableImagesResponseSchema)` to create a new message.
 */
export const GetVulnerableImagesResponseSchema: GenMessage<GetVulnerableImagesResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 18);

/**
 * @generated from message catpocs.v1.GetUnusedImagesRequest
 */
export type GetUnusedImagesRequest = Message<"catpocs.v1.GetUnusedImagesRequest"> & {
  /**
   * @generated from field: int32 older_than_days = 1;
   */
  olderThanDays: number;
};

/**
 * Describes the message catpocs.v1.GetUnusedImagesRequest.
 * Use `create(GetUnusedImagesRequestSchema)` to create a new message.
 */
export const GetUnusedImagesRequestSchema: GenMessage<GetUnusedImagesRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 19);

/**
 * @generated from message catpocs.v1.GetUnusedImagesResponse
 */
export type GetUnusedImagesResponse = Message<"catpocs.v1.GetUnusedImagesResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.UnusedImage images = 1;
   */
  images: UnusedImage[];
};

/**
 * Describes the message catpocs.v1.GetUnusedImagesResponse.
 * Use `create(GetUnusedImagesResponseSchema)` to create a new message.
 */
export const GetUnusedImagesResponseSchema: GenMessage<GetUnusedImagesResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 20);

/**
 * @generated from message catpocs.v1.CleanupUnusedImagesRequest
 */
export type CleanupUnusedImagesRequest = Message<"catpocs.v1.CleanupUnusedImagesRequest"> & {
  /**
   * @generated from field: int32 older_than_days = 1;
   */
  olderThanDays: number;

  /**
   * @generated from field: repeated string exclude_tags = 2;
   */
  excludeTags: string[];

  /**
   * @generated from field: int32 max_images_to_delete = 3;
   */
  maxImagesToDelete: number;

  /**
   * @generated from field: bool dry_run = 4;
   */
  dryRun: boolean;
};

/**
 * Describes the message catpocs.v1.CleanupUnusedImagesRequest.
 * Use `create(CleanupUnusedImagesRequestSchema)` to create a new message.
 */
export const CleanupUnusedImagesRequestSchema: GenMessage<CleanupUnusedImagesRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 21);

/**
 * @generated from message catpocs.v1.CleanupUnusedImagesResponse
 */
export type CleanupUnusedImagesResponse = Message<"catpocs.v1.CleanupUnusedImagesResponse"> & {
  /**
   * @generated from field: catpocs.v1.CleanupResult result = 1;
   */
  result?: CleanupResult;
};

/**
 * Describes the message catpocs.v1.CleanupUnusedImagesResponse.
 * Use `create(CleanupUnusedImagesResponseSchema)` to create a new message.
 */
export const CleanupUnusedImagesResponseSchema: GenMessage<CleanupUnusedImagesResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_ecr_admin, 22);

/**
 * ECRAdminService provides SuperAdmin-level operations for managing ECR registries
 *
 * @generated from service catpocs.v1.ECRAdminService
 */
export const ECRAdminService: GenService<{
  /**
   * GetRegistryOverview returns high-level statistics about the ECR registry
   *
   * @generated from rpc catpocs.v1.ECRAdminService.GetRegistryOverview
   */
  getRegistryOverview: {
    methodKind: "unary";
    input: typeof GetRegistryOverviewRequestSchema;
    output: typeof GetRegistryOverviewResponseSchema;
  },
  /**
   * ListRepositories lists all ECR repositories with metrics
   *
   * @generated from rpc catpocs.v1.ECRAdminService.ListRepositories
   */
  listRepositories: {
    methodKind: "unary";
    input: typeof ListRepositoriesRequestSchema;
    output: typeof ListRepositoriesResponseSchema;
  },
  /**
   * GetRepositoryDetails returns detailed information about a specific repository
   *
   * @generated from rpc catpocs.v1.ECRAdminService.GetRepositoryDetails
   */
  getRepositoryDetails: {
    methodKind: "unary";
    input: typeof GetRepositoryDetailsRequestSchema;
    output: typeof GetRepositoryDetailsResponseSchema;
  },
  /**
   * GetVulnerableImages returns all images with security vulnerabilities
   *
   * @generated from rpc catpocs.v1.ECRAdminService.GetVulnerableImages
   */
  getVulnerableImages: {
    methodKind: "unary";
    input: typeof GetVulnerableImagesRequestSchema;
    output: typeof GetVulnerableImagesResponseSchema;
  },
  /**
   * GetUnusedImages returns images that are not currently deployed
   *
   * @generated from rpc catpocs.v1.ECRAdminService.GetUnusedImages
   */
  getUnusedImages: {
    methodKind: "unary";
    input: typeof GetUnusedImagesRequestSchema;
    output: typeof GetUnusedImagesResponseSchema;
  },
  /**
   * CleanupUnusedImages identifies and optionally deletes unused images
   *
   * @generated from rpc catpocs.v1.ECRAdminService.CleanupUnusedImages
   */
  cleanupUnusedImages: {
    methodKind: "unary";
    input: typeof CleanupUnusedImagesRequestSchema;
    output: typeof CleanupUnusedImagesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catpocs_v1_ecr_admin, 0);

